import * as z from "zod";
import { gql } from "graphql-request";
import { Category } from "./category";

import { NewsEntryArticle, NewsEntryArticleFragment } from "./newsEntryArticle";
import { Targeting, TargetingFragment } from "../targeting";
import { NewsEntryVideo, NewsEntryVideoFragment } from "./newsEntryVideo";
import { NewsEntryImage, NewsEntryImageFragment } from "./newsEntryImage";
import {
  NewsEntryExternalLink,
  NewsEntryExternalLinkFragment,
} from "./newsEntryExternalLink";
import {
  SmallNewsEntryArticle,
  SmallNewsEntryArticleFragment,
} from "./smallNewsEntryArticle";
import {
  SmallNewsEntryExternalLink,
  SmallNewsEntryExternalLinkFragment,
} from "./smallNewsEntryExternalLink";

import { Sys, SysFragment } from "../sys";
import { RelatedMedia, RelatedMediaFragment } from "../relatedMedia";

export const NewsEntry = z.object({
  sys: Sys,

  targeting: Targeting.nullish(),
  relatedMedia: RelatedMedia.nullish(),
  category: Category.nullable(),
  categoryEn: Category.nullish(),

  sortDate: z.string().nullable(),
  newUntil: z.string().nullable(),

  localized: z
    .discriminatedUnion("__typename", [
      NewsEntryArticle,
      NewsEntryVideo,
      NewsEntryImage,
      NewsEntryExternalLink,
      SmallNewsEntryArticle,
      SmallNewsEntryExternalLink,
    ])
    .nullish(),
});

export type NewsEntry = z.infer<typeof NewsEntry>;

export const NewsEntryFragment = gql`
  fragment NewsEntryFragment on NewsEntry {
    sys {
      ...SysFragment
    }
    category {
      name
      color
    }

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    newUntil
    sortDate

    localized {
      __typename

      ... on NewsEntryVideo {
        ...NewsEntryVideoFragment
      }

      ... on NewsEntryImage {
        ...NewsEntryImageFragment
      }

      ... on NewsEntryExternalLink {
        ...NewsEntryExternalLinkFragment
      }

      ... on NewsEntryArticle {
        ...NewsEntryArticleFragment
      }

      ... on SmallNewsEntryArticle {
        ...SmallNewsEntryArticleFragment
      }

      ... on SmallNewsEntryExternalLink {
        ...SmallNewsEntryExternalLinkFragment
      }
    }
  }

  ${TargetingFragment}
  ${NewsEntryArticleFragment}
  ${NewsEntryVideoFragment}
  ${NewsEntryImageFragment}
  ${NewsEntryExternalLinkFragment}

  ${SmallNewsEntryExternalLinkFragment}
  ${SmallNewsEntryArticleFragment}
  ${SysFragment}
  ${RelatedMediaFragment}
`;
